<script lang="ts">
  import { Icon, Button, NewEntityView } from '$shared/components';
  import type { EntityViewType } from '$shared/components/types';

  interface Props {
    options: EntityViewType;
    onevent?: (payload: any) => void;
  }

  let { options, onevent }: Props = $props();

  let showMore = $state(false);

  const onClickToggle = () => {
    showMore = !showMore;
  };
</script>

<div class="entity-result" class:expanded={showMore}>
  <NewEntityView {options} {onevent} />
</div>
<div class="more-button">
  <Button maxWidth onclick={onClickToggle}>
    <div class="more-button-cntr">
      <div class="text">{showMore ? 'Less' : 'More'}</div>
      <div class="icon">
        <Icon value={showMore ? 'icon-chevron-up' : 'icon-chevron-down'} />
      </div>
    </div>
  </Button>
</div>

<style>
  .entity-result {
    position: relative;
    height: 500px;
    overflow: hidden;
  }
  .entity-result.expanded {
    height: auto;
  }
  .more-button {
    margin-top: -1px;
    padding: 24px 16px 16px;
    background-color: #fff;
    border-width: 0 1px 1px;
    border-color: rgba(0, 0, 0, 0.07);
    border-style: solid;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    position: relative;
    z-index: 9;
  }
  .more-button-cntr {
    display: flex;
    align-items: center;
  }
  .more-button-cntr .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
  }
  .entity-result {
    margin-top: 24px;
  }
  :global(.entity-result .entity-footer) {
    background-color: #fff;
    padding-left: 8px;
    border-color: rgba(0, 0, 0, 0.07);
    border-width: 0 1px 1px;
    border-style: solid;
  }
</style>
